import { TreeNode } from '../../hooks/stores/launcherElementsStore';

export const findNodeLevel = (tree: TreeNode[], id: string, currentLevel: number = 0): number | null => {
  for (const node of tree) {
    if (node.id === id) {
      return currentLevel;
    }

    if (node.children) {
      const level = findNodeLevel(node.children, id, currentLevel + 1);
      if (level !== null) {
        return level;
      }
    }
  }

  return null;
};
